import React from "react";
import { createPortal } from "react-dom";

export default function PreviewModal({ url, onClose }) {
  if (!url) return null;

  return createPortal(
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.75)",
      zIndex: 2000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <div style={{
        width: "85%",
        height: "85%",
        background: "#fff",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 12px 40px rgba(0,0,0,0.35)",
        position: "relative"
      }}>
        <iframe
          src={url}
          title="Document Preview"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
        <div
          style={{
            position: "absolute",
            top: "14px",
            right: "18px",
            cursor: "pointer",
            color: "#000",
            fontSize: "22px",
            fontWeight: 600
          }}
          onClick={onClose}
        >
          ✕
        </div>
      </div>
    </div>,
    document.body
  );
}
